// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const NotificationSettingsDialogLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-notificationsettingsdialogcontainer" */ "./NotificationSettingsDialogContainer")).then((bundle)=>{
        return {
            default: bundle.NotificationSettingsDialogContainer
        };
    });
export const LazyNotificationSettingsDialogContainer = /*#__PURE__*/ lazy(NotificationSettingsDialogLazyLoader);
